import { message } from 'antd';
import axios from './axios';

const AuthService = {
    getLoggedInUser: async () => {
        const token = localStorage.getItem("token"); 
        const user = localStorage.getItem("user");
        
        if(token && user) {
            return JSON.parse(user);
        } 

        return null;
    },
    login: async (email, password) => {
        try
        {
            const response = await axios.post('/auth/users/login', {
                email, password
            }).catch(function (error) {
                message.error(error?.response?.data?.msg);
                window.location.replace('/');
                return {errorStatus:true,...error}
              });;
           if(response?.data?.data)
           {
            const user = response.data.data;
            localStorage.setItem('token', JSON.stringify(user.token));
            localStorage.setItem('businessId', JSON.stringify(user.business_id));

            delete user.token;
            localStorage.setItem('user', JSON.stringify(user.name));
            return user;
           }else
           return response
        } catch(e) {
            console.error(e);
        }
    },
    logout: () => {
        localStorage.clear();
        window.location.reload();
    }
};

export default AuthService;